import Toolbar from './Toolbar.component';
import ColumnChooserButton from './ColumnChooserButton';
import DisplayModeToggle from './DisplayModeToggle';
import ItemsNumber from './ItemsNumber';
import Label from './Label';
import Pagination from './Pagination';
import SelectAll from './SelectAll';
import SelectSortBy from './SelectSortBy';

Toolbar.Pagination = Pagination;
Toolbar.ColumnChooserButton = ColumnChooserButton;
Toolbar.DisplayModeToggle = DisplayModeToggle;
Toolbar.ItemsNumber = ItemsNumber;
Toolbar.Label = Label;
Toolbar.SelectAll = SelectAll;
Toolbar.SelectSortBy = SelectSortBy;
export default Toolbar;
